import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#D1D2D0",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.896 7.89s.452 5.613.715 7.977c.125 1.13.822 1.79 1.965 1.812 2.174.039 4.35.041 6.524-.005 1.1-.022 1.785-.692 1.908-1.801.264-2.385.714-7.983.714-7.983M2.743 5.2h14.132M5.466 5.2c.654 0 1.218-.463 1.346-1.103l.202-1.014c.125-.467.549-.79 1.031-.79h3.528c.482 0 .905.323 1.03.79l.203 1.014c.128.64.692 1.103 1.346 1.103"
    }, null, -1)
  ])))
}
export default { render: render }